import '../httpservices/core/ajax.httpservice.core';

class CmsHttpService {

    //page id is the enum in MskPatientPortal.Services.CMS.Models.PageSpecificResource.PageSpecificResourceShared.PageIdEnum
    PageSpecificResourceItemAsync(pageId) {
        return $.get('api/Cms/CmsPageSpecificContent/' + pageId);
    }

    SharedContentResourceItemAsync(sharedContentId) {
        return $.get('api/Cms/CmsSharedSpecificContent/' + sharedContentId);
    }

    CmsSharedValidationContentBlocks(makeAsyncCall) {
        return $.get('api/Cms/CmsSharedValidationContentBlocks', null, makeAsyncCall);
    }

    CmsSubjectContent(subjectId) {
        return $.get('api/Cms/CmsSubjectContent/' + subjectId);
    }

}

export const CmsHttpSvc = new CmsHttpService();